import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import OrderedList from '@eversports/react-components/primitives/OrderedList'
import Text from '@eversports/react-components/primitives/Text'
import throttle from '@eversports/react-components/utilities/throttle'
import { makeStyles } from '@mui/styles'
import PyroForm from 'pyro-form'
import React from 'react'

import { Localized } from '../../../localization/react'
import { AddOn, AddOnsInitialValues } from '../../../typings/AdditionalInformation'

import AddOnField from './AddOnField'

interface Props {
  addOns: Array<AddOn>
  initialValues: AddOnsInitialValues
  handleChange: (values: AddOnsInitialValues) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    marginLeft: theme.layoutSpacing.dense,
  },
}))

const AddOnsComponent: React.FC<React.PropsWithChildren<Props>> = ({ initialValues, addOns, handleChange }) => {
  const classes = useStyles()
  const handleChangeThrottled = throttle(handleChange, 250)

  return (
    <Flex flexDirection="column" verticalSpacing="default" data-testid="add-on-container">
      <Text color="subtleText" fontWeight="bold" textTransform="uppercase">
        <Localized id="additional-info-add-ons" />
      </Text>
      <PyroForm initialValues={initialValues} onChange={handleChangeThrottled}>
        <div className={classes.form}>
          <OrderedList badge>
            {addOns.map(({ id, description, mandatory, fields }) => (
              <Flex key={id} flexDirection="column" verticalSpacing="default" marginBottom="default" fullWidth>
                <Text>{mandatory ? `${description} *` : description}</Text>
                {fields && fields.map((field) => <AddOnField key={field.id} field={field} mandatory={mandatory!} />)}
              </Flex>
            ))}
          </OrderedList>
        </div>
      </PyroForm>
    </Flex>
  )
}

export default AddOnsComponent
